import axios from '../axios';
import config from '../config';

export default {

    getPostsService(token) {
        return axios({
            method: 'GET',
            baseURL: config.apiUrls(),
            url: '/v1/business/post',
            headers: { token }
        })
    },

    deletePostsService(id, token) {
        return axios({
            method: 'delete',
            baseURL: config.apiUrls(),
            url: `/v1/business/post/${id}`,
            headers: {
                token,
                //  apiurl: config.apiUrls()
            }
        })
    },
    postJobService(token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/post-job`,
            //  headers: {token,  apiurl: config.apiUrls()}
        })
    },
    categoryJobService(token) {
        return axios({
            method: 'get',
            baseURL: config.apiUrls(),
            url: `/v1/business/category-job`,
            // headers: { token, apiurl: config.apiUrls() }
        })
    },
    getPostService(postId, token) {
        return axios({
            method: 'GET',
            baseURL: config.apiUrls(),
            url: `/v1/business/post/${postId}`,
            headers: { token }
        })
    },
    postBlogPostService(params, token) {
        return axios({
            method: 'put',
            baseURL: config.apiUrls(),
            url: '/v1/business/post',
            data: params,
            headers: {
                token,
                // apiurl: config.apiUrls() 
            }
        })
    }

}